// extracted by mini-css-extract-plugin
export var footer = "_mi-0";
export var inherit = "_mi-1";
export var input = "_mi-2";
export var modalContent = "_mi-3";
export var quillEditor = "_mi-4";
export var subtitle = "_mi-5";